<template>
    <div class="ui-player">
        <video-player
            ref="videoPlayer"
            class="vjs-custom-skin"
            :options="playerOptions"
            :playsinline="true"
            @ready="playerReady"
            @ended="onPlayerEnded($event)"
            @timeupdate="onPlayerTimeupdate($event)"
        >
        </video-player>

        <div class="videoPlayer-controls">
            <button
                class="swiper-button-prev prev text-white"
                @click="prev()"
                v-if="prevVideo != null"
            ></button>

            <button
                v-if="nextVideo != null"
                class="swiper-button-next next text-white"
                @click="next()"
            ></button>

            <button class="close" @click="close()">
                <app-image
                    :url="require('@/assets/img/Close.png')"
                    :is-local="false"
                    width="50"
                >
                </app-image>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import VueVideoPlayer from "vue-video-player";
import { mapState, mapActions } from "vuex";
import "video.js/dist/video-js.css";
import "videojs-contrib-hls/dist/videojs-contrib-hls";
Vue.use(VueVideoPlayer);
export default {
    name: "player",

    data() {
        return {
            fromRoute: null,

            playerBaseOptions: {
                muted: false,
                language: "es",
                sources: [
                    {
                        withCredentials: false,
                        type: "application/x-mpegURL",
                        src: false
                    }
                ],

                poster: false,

                controlBar: {
                    timeDivider: false,
                    durationDisplay: false
                },

                flash: {
                    hls: {
                        withCredentials: false
                    }
                },

                html5: {
                    hls: {
                        withCredentials: false
                    }
                }
            }
        };
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromRoute = from;
        });
    },

    beforeRouteLeave(to, from, next) {
        this.reset();

        next();
    },

    created() {
        if (!this.videos.length) {
            this.$router.push({ name: "home" });
        }
    },

    computed: {
        player: function() {
            return this.$refs.videoPlayer.player;
        },

        ...mapState({
            videos: state => state.player.videos
        }),

        currentVideoIndex: {
            get() {
                return this.$store.state.player.currentVideo;
            },

            set(value) {
                this.$store.commit("SET_PLAYER_CURRENT_VIDEO", value);
            }
        },

        currentVideo() {
            return this.videos[this.currentVideoIndex];
        },

        playerOptions() {
            return {
                ...this.playerBaseOptions,
                sources: [
                    {
                        withCredentials: false,
                        type: "application/x-mpegURL",
                        src: this.currentVideo && this.currentVideo.url
                    }
                ]
            };
        },

        nextVideo() {
            if (this.currentVideoIndex < this.videos.length - 1) {
                return this.currentVideoIndex + 1;
            }

            return null;
        },

        prevVideo() {
            if (this.videos.length > 1 && this.currentVideoIndex != 0) {
                return this.currentVideoIndex - 1;
            }

            return null;
        }
    },

    methods: {
        ...mapActions({
            reset: "RESET_PLAYER"
        }),

        playerReady(player) {
            // if player can't be autoplayed, it will be programatically muted
            // so we can bypass this restriction
            player.play().catch(() => {
                player.muted(true);
                player.play();
            });
        },

        next() {
            this.currentVideoIndex = this.nextVideo;
        },

        prev() {
            this.currentVideoIndex = this.prevVideo;
        },

        async close() {
            let handleClose = this.fromRoute
                ? this.$router.go(-1)
                : this.$router.push({ name: "home" });

            await handleClose;

            this.reset();
        },

        onPlayerEnded() {
            if (this.nextVideo) {
                this.next();
            } else {
                this.close();
            }
        },

        onPlayerTimeupdate: function() {}
    }
};
</script>

<style scoped>
.ui-player .videoPlayer-controls {
    position: absolute;
    z-index: 22222;
    top: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
}
.ui-player > .videoPlayer-controls > button.prev {
    pointer-events: all;
}
.ui-player > .videoPlayer-controls > button.next {
    pointer-events: all;
}
.ui-player > .videoPlayer-controls > button.close {
    display: block;
    width: 50px;
    height: 50px;
    pointer-events: all;
    top: 10px;
    right: 10px;
    position: absolute;
}
</style>
